import MaskedInput from "common/form/inputs/masked_input";
import FieldWrapper from "common/form/enhancers/redux_form_field_wrapper";

export default FieldWrapper(MaskedInput);
